<template>

    <main id="content" class="relative w-full pt-12 sm:pt-16 xl:pt-16">

        <section class="h-auto w-full flex flex-col items-center relative z-20">

            <div class="max-w-[calc(100%-3rem)] sm:px-4 md:px-0 sm:max-w-1.5xl xl:max-w-8xl mx-auto w-full">

                <h1 class="text-black text-4xl sm:text-4.5xl md:text-5xl lg:text-5xl xl:text-6xl font-medium mb-8 sm:mb-10 w-full relative text-center">
                    {{$root.translateString('your_cart')}} ({{ itemCount }})
                </h1>

                <div v-if="isNotEmpty(cart)" class="w-full flex flex-col xl:flex-row space-y-12 xl:space-y-0 xl:space-x-12 2xl:space-x-15 2.5xl:space-x-20">

                    <div class="flex flex-col flex-grow border-t border-customGray-border/50">

                        <div v-for="(item, key) in cart" :key="key" class="w-full flex flex-col sm:flex-row text-secondary-400 py-6 border-b border-customGray-border/50 space-y-5 sm:space-y-0">

                            <div class="flex items-start">
                                <div class="w-16 h-16 md:w-18 md:h-18 xl:w-21 xl:h-21 flex-shrink-0 flex justify-center items-center bg-customGray-background/50 p-3">
                                    <img width="70" class="w-full h-full object-contain relative -top-1" :src="item.options.image" :alt="item.options.name" />
                                </div>
                                <div class="flex flex-col flex-grow pl-5 self-center">
                                    <div class="flex flex-grow pl-0 pt-0 w-full items-start">
                                        <div class="flex">
                                            <span class="pr-2 h-full whitespace-nowrap text-sm sm:text-base !leading-snug relative -top-0.5">{{item.qty}} x</span>
                                            <span class="flex-grow flex flex-col">
                                                <span class="uppercase text-sm sm:text-base text-black !leading-tight" v-text="item.options.name"></span>
                                                <span class="w-full flex flex-col !leading-snug text-customGray-text">
                                                    <span class="w-full" v-if="item.options.type != 'visite'" v-text="item.options.combination"></span>
                                                    <span class="w-full" v-else-if="item.options.type == 'visite'">
                                                        {{parseInt(item.options.visit.adults) + parseInt(item.options.visit.kids)}}
                                                        <span v-if="item.options.visit.adults==1">{{$root.translateString('person')}}</span>
                                                        <span v-else>{{$root.translateString('people')}}</span>
                                                        <span v-if="item.options.combination">
                                                            -
                                                        {{item.options.combination.replace(" ", "")}}
                                                        </span>
                                                    </span>
                                                    <span class="w-full" v-else> Distilleria Francesco </span>
                                                </span>
                                            </span>
                                        </div>
                                    </div>
                                    <!-- <div class="py-0 flex items-center flex-grow mt-2 pl-0">
                                        <span class="flex-grow ">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </span>
                                        <a class="inline-flex space-x-2 items-center text-customGray-text xl:hover:text-black transition-all" href="javascript:void(0)" @click="updateCart(key, 0)">
                                            <span class="">{{$root.translateString('remove')}}</span>
                                        </a>
                                    </div> -->
                                </div>
                            </div>

                            <div class="flex items-center sm:space-x-10 flex-grow">
                                <div class="flex-grow flex sm:justify-end xl:justify-center items-center space-x-4 xl:space-x-8">
                                    <div class="inline-flex items-center">
                                        <button @click="decreaseQuantity(key, item)" type="buttton" class="w-6 h-6 sm:w-7.5 sm:h-7.5 flex justify-center items-center transition-all">
                                            <img class="w-full h-full" src="/images/svg/ico-minus.svg" alt="icona" />
                                        </button>

                                        <div class="w-auto h-full pointer-events-none">
                                            <input class="w-10 sm:w-12 h-8 bg-transparent text-black border-0 text-sm sm:text-base text-center" readonly type="number" min="1" v-model="item.qty" />
                                        </div>

                                        <button @click="increaseQuantity(key, item)" type="buttton" class="w-6 h-6 sm:w-7.5 sm:h-7.5 flex justify-center items-center transition-all">
                                            <img class="w-full h-full" src="/images/svg/ico-plus.svg" alt="icona" />
                                        </button>
                                    </div>
                                    <div class="flex items-center">
                                        <span class="flex-grow text-sm sm:text-base text-black whitespace-nowrap">
                                            € {{ $root.currencyDisplaySimple(parseFloat(item.price) * parseInt(item.qty)) }}
                                        </span>
                                    </div>
                                </div>
                                <div class="flex items-center">
                                    <button type="button" class="inline-flex items-center xl:hover:text-black transition-all flex-shrink-0" href="javascript:void(0)" @click="updateCart(key, 0)">
                                        <img class="w-6 h-6 hover:opacity-80 transition-all" src="/images/svg/icon-remove.svg" alt="icona" />
                                    </button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <div class="flex flex-col space-y-8 xl:w-[460px] !mb-20">

                        <div class="p-6 sm:p-10 xl:p-12 text-sm text-secondary-400 bg-customGray-background/40">

                            <div class="xl:-mt-2 mb-4 w-full bg-customGray-background/50 px-3 sm:px-6 py-3 flex justify-center items-center">
                                <span class="text-black uppercase text-xxs sm:text-xs md:text-sm text-center font-medium tracking-[.15rem]">{{$root.translateString('free_shipping')}} <span>€110</span></span>
                            </div>

                            <div class="pb-4 mb-4 text-center text-primary border-b border-customGray-border/50" v-if="missing_for_free_shipping > 0">
                                <span v-if="lang == 'it'">
                                    Sei a € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} dalla spedizione gratuita.
                                </span>
                                <span v-else>
                                    € {{$root.currencyDisplaySimple(missing_for_free_shipping)}} left for free shipping.
                                </span>
                            </div>

                            <div class="flex pb-2">
                                <div class="flex-grow">{{$root.translateString('subtotal')}}</div>
                                <div class="">
                                    € {{ $root.currencyDisplaySimple(priceTotalWt) }}
                                </div>
                            </div>

                            <div class="spedizione flex pb-4" v-if="should_be_shipped">
                                <div class="flex-grow">{{$root.translateString('shipping')}}</div>
                                <div class="">
                                    <span v-if="shipping > 0">
                                        € {{ $root.currencyDisplaySimple(shipping) }}
                                    </span>
                                    <span v-else>{{$root.translateString('free')}}</span>
                                </div>
                            </div>

                            <div class="spedizione flex pb-4" v-if="discount > 0">
                                <div class="flex-grow">{{$root.translateString('discount')}}</div>
                                <div class="">
                                    € {{ $root.currencyDisplaySimple(discount) }}
                                </div>
                            </div>

                            <div class="flex py-3 border-t border-customGray-border/50">
                                <div class="flex flex-grow flex-col">
                                    <div class="">{{$root.translateString('total')}}</div>
                                    <small class="-mt-1 text-black">{{$root.translateString('tax_included')}}</small>
                                </div>
                                <div class="text-black"> € {{ $root.currencyDisplaySimple(finalPrice) }} </div>
                            </div>

                            <div class="text-center w-full mt-3 pt-2">
                                <div class="flex w-full">
                                    <a :href="$root.langRoute('/checkout')" class="relative w-full lg:px-16 py-5 mb-2 flex items-center bg-customGray-background transition-all !duration-500 mx-auto xl:hover:!rounded-lg group">
                                        <span class="absolute w-full h-[calc(100%+1rem)] left-0 top-1/2 -translate-y-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms]"></span>
                                        <span class="absolute h-full w-[calc(100%+1rem)] top-0 left-1/2 -translate-x-1/2 border border-customGray-border/80 rounded-lg pointer-events-none group-hover:h-full group-hover:w-full transition-all !duration-[400ms] group-hover:xl:opacity-0"></span>
                                        <span class="text-black text-xs sm:text-sm xl:text-xs block w-full text-center uppercase tracking-[.11rem] font-medium">
                                            {{$root.translateString('complete_checkout')}}
                                        </span>
                                    </a>
                                </div>
                            </div>

                        </div>

                        <discount-box :lang="lang" :discount="discount"></discount-box>

                    </div>

                </div>

                <div v-else class="relative w-full text-center flex justify-center">

                    <div class="mx-auto">
                        <a :href="'/' + lang + '/shop'" class="relative flex items-center group transition-all space-x-3.5">
                            <span class="rounded-full bg-transparent group-hover:bg-white w-[40px] h-[40px] flex justify-center items-center transition-all">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40">
                                    <g id="Raggruppa_1236" data-name="Raggruppa 1236" transform="translate(-4521.689 -4109.535)">
                                    <circle id="Ellisse_73" data-name="Ellisse 73" cx="20" cy="20" r="20" transform="translate(4521.689 4109.535)" fill="#fff" opacity="0.15"/>
                                    <g id="Raggruppa_1235" data-name="Raggruppa 1235">
                                        <line id="Linea_247" data-name="Linea 247" x1="20.715" transform="translate(4531.332 4129.535)" fill="none" stroke="#9f7f49" stroke-width="1"/>
                                        <path id="Tracciato_1377" data-name="Tracciato 1377" d="M4538.828,4137.023l-7.488-7.488,7.488-7.488" fill="none" stroke="#9f7f49" stroke-width="1"/>
                                    </g>
                                    </g>
                                </svg>
                            </span>
                            <span class="text-primary-400 text-sm 1.5xl:text-xbase tracking-[3px] relative group-hover:text-black transition-all">
                                {{$root.translateString('back-to-wines')}}
                            </span>
                        </a>
                    </div>

                </div>

            </div>

        </section>

    </main>

</template>

<script>

    export default {
        props:['lang'],
        data() {
            return {
                show:false,
                cartRaw: null,
                count: 0,
                shipping: 0,
                discount: 0,
                finalPrice: 0,
                priceTotalWt: 0,
                missing_for_free_shipping: 0,
                should_be_shipped: false,
            }
        },
        mounted() {

            this.getCart();

            this.$eventHub.$on('cart.added', payload => {
                this.getCart();

                this.show = true;

                setTimeout(() => {
                    this.show = false;
                }, 5000);
            });

            this.$eventHub.$on('cart.show', payload => {
                this.show = true;
            });

            this.$eventHub.$on('discount.applied', payload => {
                this.getCart();
            });

        },
        methods: {
            increaseQuantity(key, item) {
                if(item.qty < 30) {
                    item.qty++;
                }else{
                    item.qty = 30;
                }
                this.updateCart(key, item.qty);
            },
            decreaseQuantity(key, item) {
                if(item.qty > 1) {
                    item.qty--;
                }else{
                    item.qty = 1;
                }
                this.updateCart(key, item.qty);
            },
            goToCheckout(url) {
                let temp_cart = [];

                Object.keys(this.cart).forEach((o, k) => {
                    let entry = {};
                    entry.id = this.cart[o].options.name
                    entry.quantity = this.cart[o].qty
                    temp_cart.push(entry);
                });

                /*fbq('track', 'InitiateCheckout',
                    {
                        value: parseFloat(this.priceTotalWt),
                        currency: 'EUR',
                        contents: temp_cart,
                        content_type: 'product_group'
                    }
                );*/

                window.location.href = url;
            },
            emptyCart() {
                axios.post('/api/cart/empty', {})
                .then(response => {
                    this.cartRaw = null;
                    this.shipping = 0;
                    this.priceTotalWt = 0;
                    this.finalPrice = 0;
                    this.discount = 0;
                    this.missing_for_free_shipping = 0;
                    this.should_be_shipped = false;
                })
            },
            updateCart(key, value) {

                axios.post('/api/cart/update', {
                    key: key,
                    qty: value,
                })
                .then(response => {
                    this.getCart();
                    this.$eventHub.$emit('cart.updated');
                    this.$eventHub.$emit('cart.updated.simpleQty', parseInt(response.data.count));

                    let update_type = 'add';
                    let quantity_to_track = value;

                    if(quantity_to_track == 0) {

                        quantity_to_track = this.cart[key].qty;

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "remove_from_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.cart[key].options.name.replace('<br>', ' '),
                                        item_id: this.cart[key].id,
                                        price: String(this.cart[key].options.price).replace(',', '.'),
                                        item_brand: '',
                                        item_category: this.cart[key].options.type,
                                        item_variant: this.cart[key].options.combination.toLowerCase(),
                                        quantity: quantity_to_track
                                    }
                                ]
                            }
                        });

                    } else {

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "add_to_cart",
                            ecommerce: {
                                items: [
                                    {
                                        item_name: this.cart[key].options.name.replace('<br>', ' '),
                                        item_id: this.cart[key].id,
                                        price: String(this.cart[key].options.price).replace(',', '.'),
                                        item_brand: '',
                                        item_category: this.cart[key].options.type,
                                        item_variant: this.cart[key].options.combination.toLowerCase(),
                                        quantity: quantity_to_track
                                    }
                                ]
                            }
                        });

                    }

                })
            },
            getCart() {
                axios.get('/api/cart/get')
                .then(response => {
                    //console.log(response);
                    this.cartRaw = response.data.cart;
                    this.count = response.data.count;
                    this.priceTotalWt = response.data.priceTotalWt;
                    this.finalPrice = response.data.finalPrice;
                    this.shipping = response.data.shipping;
                    this.missing_for_free_shipping = response.data.missingForFreeShipping;
                    this.discount = response.data.discount;
                    this.should_be_shipped = response.data.shouldBeShipped;

                    let products_gtm = []

                    try{

                        Object.keys(this.cartRaw).forEach(key => {
                            let entry = {};
                            entry.item_id = this.cartRaw[key].id;
                            entry.quantity = this.cartRaw[key].qty;
                            entry.item_brand = '';
                            entry.item_name = this.cartRaw[key].options.name.replace('<br>', ' ');
                            entry.price = String(this.cartRaw[key].price).replace(',', '.');
                            entry.item_variant = this.cartRaw[key].options.combination.toLowerCase();
                            entry.item_category = this.cartRaw[key].options.type;
                            products_gtm.push(entry);
                        })

                        dataLayer.push({ ecommerce: null });
                        dataLayer.push({
                            event: "view_cart",
                            ecommerce: {
                                items: products_gtm
                            }
                        });

                    }catch(e) {
                        console.log(e)
                    }

                })

            },
            isNotEmpty(object) {
                return (_.isEmpty(object) === false);
            }
        },
        beforeDestroy() {
            this.$eventHub.$off('cart.added');
            this.$eventHub.$off('cart.show');
        },
        computed: {
            cart() {
                if(this.cartRaw == null) {
                    return null;
                }

                let tmp = {};
                for (const [key, value] of Object.entries(this.cartRaw)) {
                    if(typeof value.options.isDiscount == 'undefined' || value.options.isDiscount == false) {
                        tmp[key] = value;
                    }
                }

                return tmp;
            },
            itemCount() {
                if(typeof this.cart == 'undefined' || this.cart == null) {
                    return 0;
                } else {
                    return Object.keys(this.cart).length < 10 ? '' + Object.keys(this.cart).length : Object.keys(this.cart).length;
                }
            },
        }
    }

</script>
